import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

/**
 * @description: RemoveUserFromUnitComponent is the confirmation flyout shown when a
 *               Property Manager removes a user from a Unit (Buildings flow). It mirrors
 *               the verbiage available in the mobile App. It returns `true` when the user
 *               confirms removal and `false`/undefined when cancelled.
 */
@Component({
  selector: 'app-remove-user-from-unit',
  templateUrl: './remove-user-from-unit.component.html',
  styleUrls: ['./remove-user-from-unit.component.scss'],
})
export class RemoveUserFromUnitComponent {
  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;

  constructor(
    public dialogRef: MatDialogRef<RemoveUserFromUnitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  /**
   * @description close the dialog confirming removal
   */
  removeUser(): void {
    this.dialogRef?.close(true);
  }

  /**
   * @description close the dialog without removing
   */
  cancel(): void {
    this.dialogRef?.close(false);
  }
}
